module.exports = __webpack_public_path__ + "media/images/icons/vendors/weddingstops-a86250b1edb83cf971397cf000aa3bdf.png";